import { render } from "./StoreRecommendCollection.vue?vue&type=template&id=5666794d&scoped=true"
import script from "./StoreRecommendCollection.vue?vue&type=script&lang=js"
export * from "./StoreRecommendCollection.vue?vue&type=script&lang=js"

import "./StoreRecommendCollection.vue?vue&type=style&index=0&id=5666794d&lang=scss&scoped=true"

import exportComponent from "F:\\ElectronicPointOfSales\\Mang.EposApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5666794d"]])

export default __exports__